import React from 'react'
import Button from '@skillsoft/ui/lib/Button'
import styles from './CompletionModal.module.css'
import AnnouncementModalDialog from '@skillsoft/ui/lib/AnnouncementModalDialog'
import { stringReplace } from "../../root/utils";
import * as playerapi from '../../player/api'
import feedbackModalActions from '../../feedbackModal/actions'
import { useDispatch } from 'react-redux';

export default function CompletionModal(props) {
    const { intl, isOpen, courseTitle, launchParams, orgId, studentId } = props;
    const dispatch = useDispatch();

    const onClose = () => {
        props.onClose();
    }

    const setFocus = () => {
        document.getElementById("giveFeedbackBtn").focus();
    }

    const courseModalLine3 = stringReplace(intl.pleaseletusknow, [
        { key: 'courseTitle', value: courseTitle }]);

    const launchGiveFeedback = async () => {
        const { percipioLanguageID, courseId, complianceSurveyOrgID, complianceSurveyMainProductID } = launchParams
        const response = await playerapi.fetchCertitudeLaunchURL(complianceSurveyOrgID, complianceSurveyMainProductID, percipioLanguageID, orgId, studentId, courseId)

        dispatch(feedbackModalActions.openModal(response.certitudeCourseEvalUrl));

        onClose();
    }

    return (
        <AnnouncementModalDialog
            tabIndex={1}
            isOpen={isOpen}
            onRequestClose={onClose}
            size="medium"
            onAfterOpen={setFocus}
        >
            <AnnouncementModalDialog.Header title={intl.wedloveyourinput} closeButtonKind="flat-reverse"
                imageUrl="https://cdn2.percipio.com/public/c/public/images/feedback.png"
            />
            <AnnouncementModalDialog.Body>
                <div className={styles.modalBody}>
                    <div>
                        {courseModalLine3}
                    </div>
                    <div className={styles.secondSection}>
                        {intl.itwillonlytakeafewmoments} {' '}
                        {intl.wevalueyourfeedback}
                    </div>
                </div>

            </AnnouncementModalDialog.Body>
            <AnnouncementModalDialog.Footer>
                <Button
                    id='giveFeedbackBtn'
                    label={intl.givefeedback}
                    onClick={() => launchGiveFeedback()}
                />
            </AnnouncementModalDialog.Footer>
        </AnnouncementModalDialog>
    )
}